<template>
	<div class="section-infopartners primary--text mt-10">
		<p class="text-h5 font-weight-bold my-5 text-center primary--text">Фотогалерея</p>

		<v-slide-group show-arrows>
			<v-slide-item v-for="(Item, index) in Previews" :key="index">
				<v-dialog v-model="Active[index]" scrollable>
					<template v-slot:activator="{ on, attrs }">
						<v-img v-on="on" v-bind="attrs" :src="Item" max-width="256" height="172" class="mx-1" />
					</template>
					<v-card style="overflow: hidden">
						<v-img :src="Items[index]" height="100%" contain />
						<v-btn @click="$set(Active, index, false)" color="primary" small absolute top right fab class="mt-8">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card>
				</v-dialog>
			</v-slide-item>
		</v-slide-group>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionGalleryYarmarka',
	data: () => ({
		Active: [] as Array<boolean>,
		Items: [
			require('./../assets/images/gallery/2025/figure/Grebenkina_01.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_02.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_03.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_04.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_05.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_06.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_07.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_08.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_09.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_10.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_11.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_12.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_13.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_14.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_15.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_16.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_17.jpg'),
			require('./../assets/images/gallery/2025/figure/Grebenkina_18.jpg'),
		],
		Previews: [
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_01.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_02.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_03.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_04.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_05.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_06.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_07.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_08.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_09.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_10.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_11.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_12.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_13.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_14.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_15.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_16.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_17.jpg'),
			require('./../assets/images/gallery/2025/figure/1x1/Grebenkina_18.jpg'),
		],
	}),
});
</script>
